import { render } from "./AddEditView.vue?vue&type=template&id=f1f63b7a&scoped=true"
import script from "./AddEditView.vue?vue&type=script&lang=js"
export * from "./AddEditView.vue?vue&type=script&lang=js"

import "./AddEditView.vue?vue&type=style&index=0&id=f1f63b7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f63b7a"]])

export default __exports__